import React, { FC } from "react";
import { Typography } from "@material-ui/core";
import { useHistory } from "react-router";

const MenuSectionTitle = ({
  title,
  relative,
  absolute = "/",
  external = false,
}): FC => {
  const navigate = useHistory();

  const onClick = (): void => {
    if (!external) {
      if (relative === "/null") {
        return;
      }
      navigate.push(relative);
      return;
    }
    window.location.href = absolute;
  };
  return (
    <Typography
      onClick={onClick}
      component="p"
      className={`${
        relative === "/null" ? "" : "hoverable-component break-word-text"
      }`}
      gutterBottom
      color="primary"
      style={{
        overflowWrap: "break-word",
        wordWrap: "break-word",
        maxWidth: "100%",
        whiteSpace: "normal",
        fontWeight: "700",
      }}
    >
      {title}
    </Typography>
  );
};

export default MenuSectionTitle;
